import FooterSection from "../../components/FooterSection";
import CreditsSection from "../../components/CreditsSection";

function Footer() {
  return (
    <div className="mainFooter">
      <FooterSection />
      <CreditsSection />
    </div>
  );
}

export default Footer;
